import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compose class name values into a single string and resolve Tailwind CSS class conflicts.
 *
 * @param inputs - One or more class values accepted by `clsx` (strings, arrays, objects, etc.)
 * @returns The merged class string with Tailwind utility conflicts resolved
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}